import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import type { CitizenScreen } from '../../types/navigation';
import type { CitizenSession } from './CitizenApp';
import { useStore } from '../../contexts/StoreContext';
import { MobileHeader } from '../../components/mobile/MobileHeader';
import { CaseMiniCard } from '../../components/mobile/CaseMiniCard';
type Mode = 'pcr' | 'reg';
export function CaseSearch({
  session,
  go
}: {
  session: CitizenSession;
  go: (s: CitizenScreen) => void;
}) {
  const {
    cases
  } = useStore();
  const [mode, setMode] = useState<Mode>('pcr');
  const [q, setQ] = useState('');
  const [error, setError] = useState('');
  const mine = cases.filter(c => session.guestPcr ? c.pcr === session.guestPcr : c.mobile === session.mobile);
  const search = () => {
    setError('');
    const term = q.trim();
    if (!term) {
      setError('অনুসন্ধানের জন্য তথ্য দিন।');
      return;
    }
    const found = cases.find(c => mode === 'pcr' ? c.pcr.toLowerCase() === term.toLowerCase() : c.regNo === term);
    if (!found) {
      setError('কোনো কেস পাওয়া যায়নি। তথ্য পুনরায় যাচাই করুন।');
      return;
    }
    if (found.mobile !== session.mobile) {
      setError('মালিকানা যাচাই ব্যর্থ — এই কেসটি আপনার নিবন্ধিত মোবাইল নম্বরের সাথে যুক্ত নয়। গোপনীয়তার কারণে বিস্তারিত দেখানো যাচ্ছে না।');
      return;
    }
    go({
      name: 'case',
      pcr: found.pcr
    });
  };
  return <>
      <MobileHeader appName="ডিএমপি যানবাহন সেবা" title="আমার আটককৃত যানবাহন" onBack={() => go({
      name: 'home'
    })} data-id="element-1513" data-mp="4n70tbnwymdl" />
      <div className="flex-1 overflow-y-auto no-scrollbar px-4 py-4 space-y-3" data-id="element-1514" data-mp="3vsyqk9xs3wzv">
        <div className="card p-4 space-y-3" data-id="element-1515" data-mp="dgk3v6foz4de">
          <div className="grid grid-cols-2 gap-1 rounded-lg bg-canvas p-1" data-id="element-1516" data-mp="df9036m8xwma">
            <button onClick={() => setMode('pcr')} className={`rounded-md py-1.5 text-xs font-semibold ${mode === 'pcr' ? 'bg-white text-navy shadow-card' : 'text-ink-muted'}`} data-id="element-1517" data-mp="9fi50qposuby">PCR নম্বর</button>
            <button onClick={() => setMode('reg')} className={`rounded-md py-1.5 text-xs font-semibold ${mode === 'reg' ? 'bg-white text-navy shadow-card' : 'text-ink-muted'}`} data-id="element-1518" data-mp="ig6f5abymajk">রেজিস্ট্রেশন নম্বর</button>
          </div>
          <div className="relative" data-id="element-1519" data-mp="3g9854crj794p">
            <SearchIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-soft" data-id="element-1520" data-mp="3l7rtskxiez0r" />
            <input className="input pl-9" value={q} onChange={e => setQ(e.target.value)} placeholder={mode === 'pcr' ? 'PCR-2026-00421' : 'ঢাকা মেট্রো-গ-১৫-৪৫৬৭'} aria-label="অনুসন্ধান" data-id="element-1521" data-mp="3pyhzy0drf5wi" />
          </div>
          <p className="text-[11px] text-ink-soft" data-id="element-1522" data-mp="3r1l7g5xebu1">নিবন্ধিত মোবাইল নম্বর দিয়ে মালিকানা যাচাই সাপেক্ষে তথ্য দেখানো হয়।</p>
          {error && <p className="rounded-md bg-danger-50 px-3 py-2 text-xs text-danger-700" role="alert" data-id="element-1523" data-mp="7tyatqtvv87h">{error}</p>}
          <button className="btn btn-primary w-full" onClick={search} data-id="element-1524" data-mp="cqopc9q1hvqs">অনুসন্ধান করুন</button>
        </div>
        <h2 className="text-sm font-bold text-ink" data-id="element-1525" data-mp="29lt5cto0cw2h">আমার মোবাইল নম্বরে যুক্ত কেস</h2>
        {mine.map(c => <CaseMiniCard key={c.pcr} c={c} onClick={() => go({
        name: 'case',
        pcr: c.pcr
      })} data-id="element-1526" data-mp="2ejuyk7f5ebro" />)}
      </div>
    </>;
}